/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import 'owl.carousel'
import Swiper from 'swiper';
import Lenis from '@studio-freight/lenis'
import { Navigation, Pagination, Mousewheel } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
import { initProductGallery } from './functions/product-gallery'
import lightGallery from 'lightgallery'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */

/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/legacy_steel_structures_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Mousewheel])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles

// Global variables
let residentialSwipers = new Map(); // Store multiple swipers
let commercialSwipers = new Map();
let lenis;
let isLargeScreen = window.innerWidth >= 1024;
let currentHijackedSwiper = null; // Track which swiper is currently hijacked
let swiperSections = []; // Store all swiper sections
let isScrollHijacked = false;
let wheelAccumulator = 0;
let wheelTimeout = null;
let lastWheelTime = 0;
let isProcessingWheel = false;
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */

jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	// Sticky header: toggle dark overlay on scroll
	const $stickyHeader = document.querySelector('header.header');
	if ($stickyHeader) {
		const STICKY_THRESHOLD = 80;
		function updateStickyHeader() {
			if (window.scrollY > STICKY_THRESHOLD) {
				$stickyHeader.classList.add('is-sticky');
			} else {
				$stickyHeader.classList.remove('is-sticky');
			}
		}
		window.addEventListener('scroll', updateStickyHeader, { passive: true });
		updateStickyHeader();
	}

	// Mobile dropdown toggle — small screens only, replaces off-canvas on mobile
	const mobileToggle   = document.getElementById('mobile-header-toggle');
	const mobileNavPanel = document.getElementById('mobile-nav-expand');

	if (mobileToggle && mobileNavPanel) {

		function closeAllSubMenus() {
			mobileNavPanel.querySelectorAll('li.is-sub-open').forEach(function (li) {
				li.classList.remove('is-sub-open');
				var arrow = li.querySelector(':scope > .mobile-sub-toggle');
				if (arrow) arrow.classList.remove('is-open');
			});
		}

		function closeMobileMenu() {
			mobileNavPanel.classList.remove('is-open');
			mobileToggle.setAttribute('aria-expanded', 'false');
			mobileNavPanel.setAttribute('aria-hidden', 'true');
			if ($stickyHeader) $stickyHeader.classList.remove('is-menu-open');
			closeAllSubMenus();
		}

		mobileToggle.addEventListener('click', function () {
			const isOpen = mobileNavPanel.classList.toggle('is-open');
			mobileToggle.setAttribute('aria-expanded', String(isOpen));
			mobileNavPanel.setAttribute('aria-hidden', String(!isOpen));
			if ($stickyHeader) $stickyHeader.classList.toggle('is-menu-open', isOpen);
			if (!isOpen) closeAllSubMenus();
		});

		// Inject arrow buttons for parent items and wire sub-menu toggles
		var mobileExpandNav = document.getElementById('mobile-expand-nav');
		if (mobileExpandNav) {
			mobileExpandNav.querySelectorAll('li').forEach(function (li) {
				var subMenu = li.querySelector(':scope > .sub-menu');
				if (!subMenu) return;

				var arrow = document.createElement('button');
				arrow.type = 'button';
				arrow.className = 'mobile-sub-toggle';
				arrow.setAttribute('aria-label', 'Toggle submenu');
				arrow.innerHTML = '<i class="fas fa-chevron-down"></i>';
				li.appendChild(arrow);

				arrow.addEventListener('click', function (e) {
					e.stopPropagation();
					var isSubOpen = li.classList.toggle('is-sub-open');
					arrow.classList.toggle('is-open', isSubOpen);
				});
			});
		}

		// Close when a leaf nav link (no children) is tapped
		mobileNavPanel.querySelectorAll('a').forEach(function (link) {
			link.addEventListener('click', function () {
				if (!link.closest('li').querySelector(':scope > .sub-menu')) {
					closeMobileMenu();
				}
			});
		});

		// Close when tapping outside the header
		document.addEventListener('click', function (e) {
			if ($stickyHeader && !$stickyHeader.contains(e.target)) {
				closeMobileMenu();
			}
		});
	}

    $('.accordion').each(function() {
    new Foundation.Accordion($(this), {
        allowAllClosed: true
        });
    });

    const megaMenuItems = document.querySelectorAll('.menu-item.has-mega-menu');
    
    megaMenuItems.forEach(menuItem => {
        const megaDropdown = menuItem.querySelector('.mega-dropdown');
        const megaTabs = menuItem.querySelectorAll('.mega-tab');
        let timeoutId;
        
        // Get the direct child link (first <a> tag that's a direct child)
        const menuLink = Array.from(menuItem.children).find(child => child.tagName === 'A');
        
        if (!menuLink || !megaDropdown) return;
        
        // Show mega menu when hovering over the menu item link ONLY
        menuLink.addEventListener('mouseenter', function() {
            clearTimeout(timeoutId);
            megaDropdown.classList.add('is-open');
        });
        
        // Keep menu open when hovering over the dropdown itself
        megaDropdown.addEventListener('mouseenter', function() {
            clearTimeout(timeoutId);
            megaDropdown.classList.add('is-open');
        });
        
        // Close menu when leaving the menu item
        menuItem.addEventListener('mouseleave', function() {
            timeoutId = setTimeout(() => {
                megaDropdown.classList.remove('is-open');
            }, 100);
        });
        
        // Tab switching on hover
        megaTabs.forEach(tab => {
            tab.addEventListener('mouseenter', function() {
                const tabId = this.getAttribute('data-tab');
                const parentDropdown = this.closest('.mega-dropdown');
                
                // Remove active class from all tabs in this dropdown
                parentDropdown.querySelectorAll('.mega-tab').forEach(t => {
                    t.classList.remove('active');
                });
                
                // Add active class to current tab
                this.classList.add('active');
                
                // Hide all tab contents in this dropdown
                parentDropdown.querySelectorAll('.mega-tab-content').forEach(content => {
                    content.classList.remove('active');
                });
                
                // Show current tab content
                const currentContent = parentDropdown.querySelector(`.mega-tab-content[data-content="${tabId}"]`);
                if (currentContent) {
                    currentContent.classList.add('active');
                }
            });
        });
    });


    jQuery(document).ready(function ($) {
		$('.tab-in-page-links').on('click', function (e) {
			e.preventDefault();
	
			const targetTab = $(this).data('tab');
			const targetSection = $(this).data('section');
	
			const tabLink = $('a[href="#' + targetTab + '"]');
			if (tabLink.length) {
				// Listen once for Foundation's tab change completion
				$(document).one('change.zf.tabs', function () {
					const sectionEl = $('#' + targetSection);
					if (sectionEl.length) {
						$('html, body').animate({
							scrollTop: sectionEl.offset().top - 150
						}, 600);
					}
				});
	
				// Trigger the tab change
				tabLink.trigger('click');
			}
		});
	});
	

	jQuery('#offCanvas-product').removeClass('hide');

    let $lgSwiper = document.getElementById('lg-swipper');

	var mainImagesSwiper = new Swiper(".galley-product-swiper", {

		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerColumn: 1,
		slidesPerColumnFill: 'row',

		// navigation: {
		//   nextEl: ".swiper-button-next",
		//   prevEl: ".swiper-button-prev",
		// },

		// pagination: {
		//     el: '.serviceSwiper .swiper-pagination',
		//     clickable: true,
		// },



		breakpoints: {
			640: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1024: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1200: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1440: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
		},

		on: {
			init: function () {
				const lg = lightGallery($lgSwiper, {
					// selector: '.swiper-slide',
					plugins: [lgThumbnail],
					licenseKey: 'B42122F4-AE41-435C-BA3A-91BFC685EE99',
					speed: 500,
				});

				// Before closing lightGallery, make sure swiper slide
				// is aligned with the lightGallery active slide
				$lgSwiper.addEventListener('lgBeforeClose', () => {
					mainImagesSwiper.slideTo(lg.index, 0)
				});
			}
		}

	});

	var thumbnailsSwiper = new Swiper(".galley-product-thumbs-swiper", {

		direction: "vertical",
		//spaceBetween: 20,
		autoHeight: true,
		loop: false,
		slidesPerView: 4,
		//slidesPerColumn: 1, 
		// slidesPerColumnFill: 'row',

		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

		// pagination: {
		//     el: '.serviceSwiper .swiper-pagination',
		//     clickable: true,
		// },




	});


	thumbnailsSwiper.on('click', function () {
		var clickedIndex = thumbnailsSwiper.clickedIndex;
		if (clickedIndex !== undefined) {
			mainImagesSwiper.slideTo(clickedIndex);
		}
	});

	mainImagesSwiper.on('slideChange', function () {
		var activeIndex = mainImagesSwiper.activeIndex;
		thumbnailsSwiper.slideTo(activeIndex);
	});


	var mainImagesSwiper = new Swiper(".photos-swiper", {

		direction: 'horizontal',
		spaceBetween: 30,
		slidesPerView: 1,
		slidesPerColumn: 1,
		//initialSlide: 1,
		watchSlidesProgress: true,
		observeParents: true,
		//slidesPerColumnFill: 'row',
		pagination: {
			el: '.photos-swiper-pagination',
			clickable: true,
		},

		breakpoints: {
			640: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1024: {
				slidesPerView: 1,
				slidesPerColumn: 1,
			},
			1200: {
				slidesPerView: 2,
				slidesPerColumn: 1,
			},
			1440: {
				slidesPerView: 2,
				slidesPerColumn: 1,
			},
		},

	});
    

	// About Swiper (unchanged)
	const swiper = new Swiper(".aboutSwiper", {
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			1440: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			}
		},
		on: {
			'init': function() {
				new Foundation.Equalizer(jQuery(".aboutSwiper.swiper-container")).applyHeight();
			},
		},
	});

	// Initialize all residential swipers
	initAllResidentialSwipers();
    initAllCommercialSwipers();
    
    // Initialize Lenis after Swipers
    // initLenisScroll();

    // Handle window resize
    window.addEventListener('resize', () => {
        isLargeScreen = window.innerWidth >= 1024;
        // Update all swipers on resize
        residentialSwipers.forEach((swiper, id) => {
            if (swiper && !swiper.destroyed) {
                swiper.update();
            }
        });
        
        commercialSwipers.forEach((swiper, id) => {
            if (swiper && !swiper.destroyed) {
                swiper.update();
            }
        });
    });

    const zipData = {
        // CURRENTLY SERVING STATES
        
        // Texas
        '75201': { state: 'Texas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '77001': { state: 'Texas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '78701': { state: 'Texas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '73301': { state: 'Texas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '79901': { state: 'Texas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '76101': { state: 'Texas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Oklahoma
        '73102': { state: 'Oklahoma', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '74101': { state: 'Oklahoma', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '73401': { state: 'Oklahoma', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // New Mexico
        '87101': { state: 'New Mexico', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '88001': { state: 'New Mexico', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '87401': { state: 'New Mexico', served: false, standardLeadTime: null, widespanLeadTime: null },
        
        // Arkansas (Troup Area)
        '72201': { state: 'Arkansas', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        '71901': { state: 'Arkansas', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        '72701': { state: 'Arkansas', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        
        // Louisiana (Troup Area)
        '70112': { state: 'Louisiana', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        '71101': { state: 'Louisiana', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        '70506': { state: 'Louisiana', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        
        // Mississippi (Troup Area)
        '39201': { state: 'Mississippi', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        '39501': { state: 'Mississippi', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        '38801': { state: 'Mississippi', served: true, standardLeadTime: null, widespanLeadTime: '3-6 weeks' },
        
        // Tennessee
        '37902': { state: 'Tennessee', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '3-6 weeks' },
        '37201': { state: 'Tennessee', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '3-6 weeks' },
        '38103': { state: 'Tennessee', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '3-6 weeks' },
        '37402': { state: 'Tennessee', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '3-6 weeks' },
        
        // Missouri
        '63101': { state: 'Missouri', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '64108': { state: 'Missouri', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '65201': { state: 'Missouri', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Kansas
        '66101': { state: 'Kansas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '67202': { state: 'Kansas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '66502': { state: 'Kansas', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Ohio
        '43215': { state: 'Ohio', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '44141': { state: 'Ohio', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '44101': { state: 'Ohio', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '45202': { state: 'Ohio', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Kentucky
        '40202': { state: 'Kentucky', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '40502': { state: 'Kentucky', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '41101': { state: 'Kentucky', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '42101': { state: 'Kentucky', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Indiana
        '46201': { state: 'Indiana', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '46204': { state: 'Indiana', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '46802': { state: 'Indiana', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '47901': { state: 'Indiana', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Illinois
        '60601': { state: 'Illinois', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '61701': { state: 'Illinois', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '62701': { state: 'Illinois', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Iowa
        '50309': { state: 'Iowa', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '52240': { state: 'Iowa', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '51501': { state: 'Iowa', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Wisconsin
        '53201': { state: 'Wisconsin', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '53202': { state: 'Wisconsin', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '53703': { state: 'Wisconsin', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '54601': { state: 'Wisconsin', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Michigan
        '48201': { state: 'Michigan', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '49503': { state: 'Michigan', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '48104': { state: 'Michigan', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // West Virginia
        '25301': { state: 'West Virginia', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '26505': { state: 'West Virginia', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '25401': { state: 'West Virginia', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Pennsylvania (PA Area - Widespans)
        '19019': { state: 'Pennsylvania', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '15219': { state: 'Pennsylvania', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '17101': { state: 'Pennsylvania', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '19103': { state: 'Pennsylvania', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        
        // Washington
        '98101': { state: 'Washington', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '99201': { state: 'Washington', served: false, standardLeadTime: null, widespanLeadTime: null },
        '98501': { state: 'Washington', served: false, standardLeadTime: null, widespanLeadTime: null },
        
        // Massachusetts (PA Area - Widespans)
        '02101': { state: 'Massachusetts', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '01101': { state: 'Massachusetts', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '02601': { state: 'Massachusetts', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        
        // Nevada
        '89101': { state: 'Nevada', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '89501': { state: 'Nevada', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '89701': { state: 'Nevada', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // California
        '90210': { state: 'California', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '94102': { state: 'California', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '92101': { state: 'California', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '95814': { state: 'California', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '90001': { state: 'California', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // New York (PA Area - Widespans)
        '10001': { state: 'New York', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '14201': { state: 'New York', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '12201': { state: 'New York', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        
        // Arizona
        '85001': { state: 'Arizona', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '85701': { state: 'Arizona', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '86001': { state: 'Arizona', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Oregon
        '97201': { state: 'Oregon', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '97501': { state: 'Oregon', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '97301': { state: 'Oregon', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '97701': { state: 'Oregon', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Utah
        '84720': { state: 'Utah', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '84101': { state: 'Utah', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '84601': { state: 'Utah', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '84321': { state: 'Utah', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // Minnesota
        '55101': { state: 'Minnesota', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '55401': { state: 'Minnesota', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        '55802': { state: 'Minnesota', served: true, standardLeadTime: '1-3 weeks', widespanLeadTime: '2-4 weeks' },
        
        // New Jersey (PA Area - Widespans)
        '07101': { state: 'New Jersey', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '08608': { state: 'New Jersey', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '08540': { state: 'New Jersey', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        
        // Maryland (PA Area - Widespans)
        '21201': { state: 'Maryland', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '20901': { state: 'Maryland', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        '21801': { state: 'Maryland', served: true, standardLeadTime: null, widespanLeadTime: '2-6 weeks' },
        
        // NOT SERVED STATES
        '30301': { state: 'Georgia', served: false, standardLeadTime: null, widespanLeadTime: null },
        '31401': { state: 'Georgia', served: false, standardLeadTime: null, widespanLeadTime: null },
        '30901': { state: 'Georgia', served: false, standardLeadTime: null, widespanLeadTime: null },
        '27601': { state: 'North Carolina', served: false, standardLeadTime: null, widespanLeadTime: null },
        '28202': { state: 'North Carolina', served: false, standardLeadTime: null, widespanLeadTime: null },
        '27401': { state: 'North Carolina', served: false, standardLeadTime: null, widespanLeadTime: null },
        '29201': { state: 'South Carolina', served: false, standardLeadTime: null, widespanLeadTime: null },
        '29401': { state: 'South Carolina', served: false, standardLeadTime: null, widespanLeadTime: null },
        '29615': { state: 'South Carolina', served: false, standardLeadTime: null, widespanLeadTime: null },
        '35201': { state: 'Alabama', served: false, standardLeadTime: null, widespanLeadTime: null },
        '36104': { state: 'Alabama', served: false, standardLeadTime: null, widespanLeadTime: null },
        '35801': { state: 'Alabama', served: false, standardLeadTime: null, widespanLeadTime: null },
        '99501': { state: 'Alaska', served: false, standardLeadTime: null, widespanLeadTime: null },
        '99801': { state: 'Alaska', served: false, standardLeadTime: null, widespanLeadTime: null },
        '99701': { state: 'Alaska', served: false, standardLeadTime: null, widespanLeadTime: null },
        '96801': { state: 'Hawaii', served: false, standardLeadTime: null, widespanLeadTime: null },
        '96720': { state: 'Hawaii', served: false, standardLeadTime: null, widespanLeadTime: null },
        '96734': { state: 'Hawaii', served: false, standardLeadTime: null, widespanLeadTime: null },
        '04101': { state: 'Maine', served: false, standardLeadTime: null, widespanLeadTime: null },
        '04401': { state: 'Maine', served: false, standardLeadTime: null, widespanLeadTime: null },
        '04730': { state: 'Maine', served: false, standardLeadTime: null, widespanLeadTime: null },
        '33101': { state: 'Florida', served: false, standardLeadTime: null, widespanLeadTime: null },
        '32301': { state: 'Florida', served: false, standardLeadTime: null, widespanLeadTime: null },
        '32801': { state: 'Florida', served: false, standardLeadTime: null, widespanLeadTime: null },
        '80202': { state: 'Colorado', served: false, standardLeadTime: null, widespanLeadTime: null },
        '80501': { state: 'Colorado', served: false, standardLeadTime: null, widespanLeadTime: null },
        '81301': { state: 'Colorado', served: false, standardLeadTime: null, widespanLeadTime: null },
        '83702': { state: 'Idaho', served: false, standardLeadTime: null, widespanLeadTime: null },
        '83501': { state: 'Idaho', served: false, standardLeadTime: null, widespanLeadTime: null },
        '83401': { state: 'Idaho', served: false, standardLeadTime: null, widespanLeadTime: null },
        '59101': { state: 'Montana', served: false, standardLeadTime: null, widespanLeadTime: null },
        '59601': { state: 'Montana', served: false, standardLeadTime: null, widespanLeadTime: null },
        '59801': { state: 'Montana', served: false, standardLeadTime: null, widespanLeadTime: null },
        '82001': { state: 'Wyoming', served: false, standardLeadTime: null, widespanLeadTime: null },
        '82601': { state: 'Wyoming', served: false, standardLeadTime: null, widespanLeadTime: null },
        '83001': { state: 'Wyoming', served: false, standardLeadTime: null, widespanLeadTime: null },
        '58102': { state: 'North Dakota', served: false, standardLeadTime: null, widespanLeadTime: null },
        '58501': { state: 'North Dakota', served: false, standardLeadTime: null, widespanLeadTime: null },
        '58201': { state: 'North Dakota', served: false, standardLeadTime: null, widespanLeadTime: null },
        '57101': { state: 'South Dakota', served: false, standardLeadTime: null, widespanLeadTime: null },
        '57701': { state: 'South Dakota', served: false, standardLeadTime: null, widespanLeadTime: null },
        '57401': { state: 'South Dakota', served: false, standardLeadTime: null, widespanLeadTime: null },
        '68102': { state: 'Nebraska', served: false, standardLeadTime: null, widespanLeadTime: null },
        '68501': { state: 'Nebraska', served: false, standardLeadTime: null, widespanLeadTime: null },
        '69001': { state: 'Nebraska', served: false, standardLeadTime: null, widespanLeadTime: null },
        '05601': { state: 'Vermont', served: false, standardLeadTime: null, widespanLeadTime: null },
        '05401': { state: 'Vermont', served: false, standardLeadTime: null, widespanLeadTime: null },
        '05301': { state: 'Vermont', served: false, standardLeadTime: null, widespanLeadTime: null },
        '03101': { state: 'New Hampshire', served: false, standardLeadTime: null, widespanLeadTime: null },
        '03301': { state: 'New Hampshire', served: false, standardLeadTime: null, widespanLeadTime: null },
        '03801': { state: 'New Hampshire', served: false, standardLeadTime: null, widespanLeadTime: null },
        '06101': { state: 'Connecticut', served: false, standardLeadTime: null, widespanLeadTime: null },
        '06511': { state: 'Connecticut', served: false, standardLeadTime: null, widespanLeadTime: null },
        '06901': { state: 'Connecticut', served: false, standardLeadTime: null, widespanLeadTime: null },
        '02901': { state: 'Rhode Island', served: false, standardLeadTime: null, widespanLeadTime: null },
        '02840': { state: 'Rhode Island', served: false, standardLeadTime: null, widespanLeadTime: null },
        '02904': { state: 'Rhode Island', served: false, standardLeadTime: null, widespanLeadTime: null },
        '19901': { state: 'Delaware', served: false, standardLeadTime: null, widespanLeadTime: null },
        '19801': { state: 'Delaware', served: false, standardLeadTime: null, widespanLeadTime: null },
        '19958': { state: 'Delaware', served: false, standardLeadTime: null, widespanLeadTime: null },
        '23219': { state: 'Virginia', served: false, standardLeadTime: null, widespanLeadTime: null },
        '22201': { state: 'Virginia', served: false, standardLeadTime: null, widespanLeadTime: null },
        '23451': { state: 'Virginia', served: false, standardLeadTime: null, widespanLeadTime: null }
    };

    const zipForm = document.getElementById('zipForm');
    const zipInput = document.getElementById('zipInput');

    if (zipForm && zipInput) {

    // Build set of served states
    const servedStates = new Set(
        Object.values(zipData)
        .filter(v => v && v.state && v.served)
        .map(v => v.state.toLowerCase())
    );

    // Initialize map colors
    function initMapColors() {
        const allStates = document.querySelectorAll('.state-path');
        allStates.forEach(state => {
            state.classList.remove('your-state');
            const stateAttr = (state.getAttribute('data-state') || '').toLowerCase();
            
            if (servedStates.has(stateAttr)) {
                state.style.fill = '#203B4C';
                state.classList.add('state-service');
            } else {
                state.style.fill = '#E2E2E2';
                state.classList.remove('state-service');
            }
            
            state.style.stroke = '';
            state.style.strokeWidth = '';
            state.style.transform = '';
            state.style.transition = '';
        });
    }

    initMapColors();

    // Highlight selected state
    function highlightState(stateName) {
        if (!stateName) return;
        
        initMapColors();
        
        const targetState = Array.from(document.querySelectorAll('.state-path')).find(state => {
            const s = state.getAttribute('data-state');
            return s && s.toLowerCase() === stateName.toLowerCase();
        });
        
        if (!targetState) return;
        
        targetState.classList.add('your-state');
        targetState.style.fill = '#B49B55';
        targetState.style.stroke = '#8B7355';
        targetState.style.strokeWidth = '2';
        targetState.style.transform = 'scale(1.02)';
        targetState.style.transformOrigin = 'center';
        targetState.style.transition = 'all 0.3s ease';
        
        setTimeout(() => {
            targetState.style.transform = 'scale(1)';
        }, 300);
    }

    // Map click handlers
    const statePaths = document.querySelectorAll('.state-path');
    statePaths.forEach(path => {
        path.addEventListener('click', function() {
            const stateName = this.getAttribute('data-state');
            if (!stateName) return;
            
            const stateZip = Object.keys(zipData).find(zip =>
                zipData[zip] && zipData[zip].state && zipData[zip].state.toLowerCase() === stateName.toLowerCase()
            );
            
            if (stateZip) {
                zipInput.value = stateZip;
                checkZipCode(stateZip);
            } else {
                highlightState(stateName);
            }
        });
    });

    // Form submission
    zipForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const zip = zipInput.value.trim();
        
        if (!zip || zip.length !== 5 || !/^\d{5}$/.test(zip)) {
            showResult('Please enter a valid 5-digit ZIP code');
            return;
        }
        
        checkZipCode(zip);
    });

    // ZIP input validation
    zipInput.addEventListener('input', function(e) {
        e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 5);
    });

    function checkZipCode(zip) {
        const data = zipData[zip];
        
        if (data && data.served) {
            let message = "";

            // Build message only for available times
            if (data.standardLeadTime) {
              message += `<strong>Standard Units:</strong> The lead time for your ZIP code is between 
              <span class="font-color-primary">${data.standardLeadTime}</span>.<br><br>`;
            }
            
            if (data.widespanLeadTime) {
              message += `<strong>Widespans:</strong> The lead time for your ZIP code is between 
              <span class="font-color-primary">${data.widespanLeadTime}</span>.`;
            }
            
            // Fallback if both missing
            // if (!message) {
            //   message = "<strong>Lead time data not available for this ZIP code.</strong>";
            // }
            
            showResult(message);
            
            highlightState(data.state);
        } else if (data && !data.served) {
            // Check if this state has ANY served ZIP codes (partial service)
            const stateHasServedZips = Object.values(zipData).some(
                entry => entry.state === data.state && entry.served === true
            );
            
            if (stateHasServedZips) {
                // State is partially served - prompt user to enter specific ZIP
                showResult('Please enter your ZIP code above to get precise lead time for your area.');
            } else {
                // State is completely not served
                showResult(`Sorry, we don't currently service ${data.state}.`);
            }
            highlightState(data.state);
        } else {
            showResult('ZIP code not found. Please check and try again.');
        }
    }

    function showResult(message) {
        const resultEl = document.getElementById('zipResult');
        if (resultEl) {
            resultEl.innerHTML = message;
        }
    }

}
    // =====================================================
    // Save Product Button — opens modal & populates CF7
    // =====================================================
    jQuery(document).on('click', '.save-product-btn', function (e) {
        e.preventDefault();

        var $btn        = jQuery(this);
        var productName = $btn.data('product-name') || '';
        var productUrl  = $btn.data('product-url')  || '#';
        var productImage = $btn.data('product-image') || '';

        // Populate modal display elements
        jQuery('#save-product-name').text(productName);
        jQuery('#save-product-link').attr('href', productUrl);

        if (productImage) {
            jQuery('#save-product-image').html(
                '<img src="' + productImage + '" alt="' + productName + '" style="width:100%;margin-bottom:1rem;">'
            );
        } else {
            jQuery('#save-product-image').empty();
        }

        // Populate CF7 hidden fields before opening
        jQuery('#save-product-modal input[name="product-name"]').val(productName);
        jQuery('#save-product-modal input[name="product-url"]').val(productUrl);

        // Open Foundation Reveal modal
        jQuery('#save-product-modal').foundation('open');
    });
    // =====================================================
    // End Save Product Button
    // =====================================================

    initProductGallery('.product-gallery');
});

/** ============================================================= *
 *  --------------- HEADER LOGO ANIMATION - START --------------- *
 *  ============================================================= */
/** ============================================================= *
 *  --------------- HEADER LOGO ANIMATION - START --------------- *
 *  ============================================================= */
function initHeaderLogoAnimation() {
    // Only run on XL screens (1440px+) and if animation class exists
    if (window.innerWidth < 1440) return;
    
    const heroSection = document.querySelector('#home-section_0.has-animation');
    if (!heroSection) return;

    const splitMenu = document.querySelector('.split-menu.has-logo-animation');
    const topBar = document.querySelector('.top-bar');
    const heroLogo = document.querySelector('.hero-logo-img');
    const headerLogoImg = document.querySelector('.header-logo-img');
    const leftMenu = document.querySelector('.left-menu');
    const rightMenu = document.querySelector('.right-menu');
    
    if (!splitMenu || !topBar || !heroLogo) return;

    let scrollProgress = 0;
    let animationComplete = false;
    let ticking = false;

    const STAGE_1_THRESHOLD = 350;  // Logo fully in header
    const STAGE_2_THRESHOLD = 650;  // Welcome text visible

    function easeOutCubic(x) {
        return 1 - Math.pow(1 - x, 3);
    }

    function lerp(start, end, progress) {
        return start + (end - start) * progress;
    }

    function updateAnimation() {
        if (animationComplete) return;

        // Stage 1: Logo shrinks and moves to header
        if (scrollProgress <= STAGE_1_THRESHOLD) {
            const progress = easeOutCubic(scrollProgress / STAGE_1_THRESHOLD);
            
            const startSize = 590; // Start at 590px
            const endSize = 0;     // Shrink to 0px
            const currentSize = lerp(startSize, endSize, progress);
            
            const startTop = 50; // vh
            const endTop = 3.5; // vh
            const currentTop = lerp(startTop, endTop, progress);
            
            heroLogo.style.width = `${currentSize}px`;
            heroLogo.style.height = 'auto';
            heroLogo.parentElement.style.top = `${currentTop}vh`;
            heroLogo.parentElement.style.transform = 'translateX(-50%)';
            heroLogo.parentElement.style.opacity = '1';
            
            // Show header background and logo as animated logo shrinks
            if (progress > 0.7) {
                topBar.classList.add('header-visible');
                splitMenu.classList.add('menu-visible');
            } else {
                topBar.classList.remove('header-visible');
                splitMenu.classList.remove('menu-visible');
            }
        }
        // Stage 2: Logo completely hidden, fade out container, show content
        else if (scrollProgress <= STAGE_2_THRESHOLD) {
            const progress = easeOutCubic((scrollProgress - STAGE_1_THRESHOLD) / (STAGE_2_THRESHOLD - STAGE_1_THRESHOLD));
            
            // Keep logo at 0px size and final position
            heroLogo.style.width = '0px';
            heroLogo.parentElement.style.top = '3.5vh';
            
            // Keep header visible throughout Stage 2
            topBar.classList.add('header-visible');
            splitMenu.classList.add('menu-visible');
            
            // Fade out the animated hero logo container completely
            heroLogo.parentElement.style.opacity = `${1 - progress}`;
            
            // Show hero content
            if (progress > 0.3) {
                heroSection.classList.add('content-visible');
            } else {
                heroSection.classList.remove('content-visible');
            }
        }
        // Stage 3: Complete - hero logo completely hidden
        else {
            animationComplete = true;
            document.body.classList.remove('scroll-locked');
            
            // Ensure header stays visible
            topBar.classList.add('header-visible');
            splitMenu.classList.add('menu-visible');
            
            // Ensure hero logo is completely hidden
            if (heroLogo && heroLogo.parentElement) {
                heroLogo.parentElement.style.opacity = '0';
                heroLogo.parentElement.style.display = 'none';
            }
            
            // Ensure content is visible
            heroSection.classList.add('content-visible');
            
            // Re-enable Lenis
            if (typeof lenis !== 'undefined' && lenis) {
                lenis.start();
            }
        }

        ticking = false;
    }

    function handleWheel(e) {
        if (animationComplete) return;
        
        e.preventDefault();
        
        if (e.deltaY < 0) {
            scrollProgress -= Math.abs(e.deltaY) * 0.4;
            // If scrolling back, reset animation complete flag
            if (scrollProgress < STAGE_2_THRESHOLD) {
                animationComplete = false;
                document.body.classList.add('scroll-locked');
                if (typeof lenis !== 'undefined' && lenis) {
                    lenis.stop();
                }
                // Show hero logo again
                if (heroLogo && heroLogo.parentElement) {
                    heroLogo.parentElement.style.display = 'block';
                }
            }
        } else {
            scrollProgress += Math.abs(e.deltaY) * 0.4;
        }
        
        scrollProgress = Math.max(0, Math.min(scrollProgress, STAGE_2_THRESHOLD + 1));

        if (!ticking) {
            requestAnimationFrame(updateAnimation);
            ticking = true;
        }
    }

    // Lock scroll initially
    document.body.classList.add('scroll-locked');
    
    // Pause Lenis
    if (typeof lenis !== 'undefined' && lenis) {
        lenis.stop();
    }

    // Initialize logo at starting position (590px, centered)
    heroLogo.parentElement.style.top = '50vh';
    heroLogo.parentElement.style.transform = 'translateX(-50%)';
    heroLogo.style.width = '590px';
    heroLogo.parentElement.style.opacity = '1';
    heroLogo.parentElement.style.display = 'block';
    
    // Hide header initially
    topBar.classList.remove('header-visible');
    splitMenu.classList.remove('menu-visible');

    window.addEventListener('wheel', handleWheel, { passive: false });

    let touchStartY = 0;
    window.addEventListener('touchstart', (e) => {
        if (!animationComplete) {
            touchStartY = e.touches[0].clientY;
        }
    }, { passive: false });

    window.addEventListener('touchmove', (e) => {
        if (!animationComplete) {
            e.preventDefault();
            const touchY = e.touches[0].clientY;
            const deltaY = touchStartY - touchY;
            
            scrollProgress += deltaY * 0.25;
            scrollProgress = Math.max(0, Math.min(scrollProgress, STAGE_2_THRESHOLD + 1));
            
            touchStartY = touchY;

            if (!ticking) {
                requestAnimationFrame(updateAnimation);
                ticking = true;
            }
        }
    }, { passive: false });

    updateAnimation();
}

/** ============================================================= *
 *  ---------------- HEADER LOGO ANIMATION - END ---------------- *
 *  ============================================================= */

/** ============================================================= *
 *  ------------- RESIDENTIAL SWIPERS INITIALIZATION ------------ *
 *  ============================================================= */

function initAllResidentialSwipers() {
    const swiperContainers = document.querySelectorAll('.residential-swiper');
    
    swiperContainers.forEach((container, index) => {
        const swiperId = `residential-swiper-${index}`;
        
        // Buttons are SIBLINGS of the swiper, not children — walk up then back down
        const wrapper = container.closest('.swiper-container-wrapper');
        const prevBtn = wrapper ? wrapper.querySelector('.swiper-button-prev') : null;
        const nextBtn = wrapper ? wrapper.querySelector('.swiper-button-next') : null;
        
        const swiperInstance = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 20,
            allowTouchMove: true,
            simulateTouch: true,
            breakpoints: {
                1440: { slidesPerView: 3, spaceBetween: 30 },
                1024: { slidesPerView: 3, spaceBetween: 30 },
                640:  { slidesPerView: 1, spaceBetween: 20  }
            },
            navigation: (prevBtn && nextBtn) ? {
                prevEl: prevBtn,
                nextEl: nextBtn,
            } : false,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            on: {
                init: function() {
                    if (typeof Foundation !== 'undefined' && typeof jQuery !== 'undefined') {
                        new Foundation.Equalizer(jQuery(container)).applyHeight();
                    }
                },
            },
        });

        residentialSwipers.set(swiperId, swiperInstance);
        container.setAttribute('data-swiper-id', swiperId);
        
        const parentSection = container.closest('section');
        if (parentSection) {
            swiperSections.push({
                id: swiperId,
                section: parentSection,
                swiper: swiperInstance,
                container: container
            });
        }
    });
}

function initAllCommercialSwipers() {
    // Find all commercial swiper containers
    const swiperContainers = document.querySelectorAll('.commercial-swiper');
    
    swiperContainers.forEach((container, index) => {
        const swiperId = `commercial-swiper-${index}`;
        
        // Create swiper instance
        const swiperInstance = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 20,
            allowTouchMove: true,
            simulateTouch: true,
            breakpoints: {
                1440: { 
                    slidesPerView: 3, 
                    spaceBetween: 30 
                },
                1024: { 
                    slidesPerView: 3, 
                    spaceBetween: 30 
                },
                640: { 
                    slidesPerView: 1, 
                    spaceBetween: 20 
                }
            },
            navigation: !isLargeScreen ? {
                nextEl: container.querySelector(".swiper-button-next"),
                prevEl: container.querySelector(".swiper-button-prev"),
            } : false,
            // mousewheel: {
            //     forceToAxis: true,
            //     sensitivity: 1,
            //     releaseOnEdges: true,
            //     enabled: false,
            // },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            on: {
                init: function() {
                    if (typeof Foundation !== 'undefined' && typeof jQuery !== 'undefined') {
                        new Foundation.Equalizer(jQuery(container)).applyHeight();
                    }
                },
            },
        });

        // Store swiper instance
        commercialSwipers.set(swiperId, swiperInstance);
        
        // Store the container element with ID for reference
        container.setAttribute('data-swiper-id', swiperId);
        
        // Find and store the parent section
        const parentSection = container.closest('section');
        if (parentSection) {
            swiperSections.push({
                id: swiperId,
                section: parentSection,
                swiper: swiperInstance,
                container: container
            });
        }
    });
}

/** ============================================================= *
 *  ----------------- LENIS INTEGRATION ------------------------- *
 *  ============================================================= */
function initLenisScroll() {
    lenis = new Lenis({
        smooth: true,
        lerp: 0.08,
        wheelMultiplier: 1.2,
        smoothWheel: true,
        smoothTouch: false
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    if (swiperSections.length === 0 || !isLargeScreen) {
        return;
    }

    
    // Scroll-based with precise container detection
    lenis.on('scroll', ({ scroll }) => {
        handleMultipleSwiperScrollHijack(scroll);
    });
    window.addEventListener('wheel', handleWheelEvent, { passive: false });

    // Keep the existing scroll velocity logic for safety
    let lastScrollY = 0;
    let scrollVelocity = 0;
    lenis.on('scroll', ({ scroll }) => {
        scrollVelocity = Math.abs(scroll - lastScrollY);
        
        if (isScrollHijacked && currentHijackedSwiper) {
            const currentSection = getCurrentHijackedSection();
            if (currentSection) {
                const containerRect = currentSection.container.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const containerCenter = (containerRect.top + containerRect.bottom) / 2;
                const viewportCenter = windowHeight / 2;
                
                // Force break hijacking with container-based logic
                if (Math.abs(containerCenter - viewportCenter) > containerRect.height * 0.5 || scrollVelocity > 30) {
                    resumeNormalScroll();
                }
            }
        }
        lastScrollY = scroll;
    });
}

function handleMultipleSwiperScrollHijack(scrollY) {
    if (swiperSections.length === 0 || !isLargeScreen) return;

    const windowHeight = window.innerHeight;
    let shouldHijackSection = null;

    // Check each swiper CONTAINER specifically, not the entire section
    swiperSections.forEach(sectionData => {
        const containerRect = sectionData.container.getBoundingClientRect();
        const containerTop = containerRect.top;
        const containerBottom = containerRect.bottom;
        const containerHeight = containerRect.height;
        const viewportCenter = windowHeight / 2;
        
        // More precise detection - check if container is in viewport center area
        const containerCenter = (containerTop + containerBottom) / 2;
        const distanceFromCenter = Math.abs(containerCenter - viewportCenter);
        
        // Only hijack if:
        // 1. Container is actually visible in viewport
        // 2. Container center is close to viewport center
        // 3. Container has reasonable size (not collapsed)
        const isContainerVisible = containerTop < windowHeight && containerBottom > 0;
        const isContainerCentered = distanceFromCenter < containerHeight * 0.3; // Tighter threshold
        const hasReasonableHeight = containerHeight > 100;
        
        if (isContainerVisible && isContainerCentered && hasReasonableHeight) {
            shouldHijackSection = sectionData;
        }
    });

    // Handle hijacking logic (same as before)
    if (shouldHijackSection && (!isScrollHijacked || currentHijackedSwiper !== shouldHijackSection.id)) {
        if (isScrollHijacked && currentHijackedSwiper !== shouldHijackSection.id) {
            resumeNormalScroll();
        }
        startSwiperHijacking(shouldHijackSection);
    } else if (!shouldHijackSection && isScrollHijacked) {
        resumeNormalScroll();
    }
}

// Enhanced wheel event handler with container-specific detection
function handleWheelEvent(e) {
    if (!isScrollHijacked || !isLargeScreen || !currentHijackedSwiper) return;
    
    const currentSection = getCurrentHijackedSection();
    if (!currentSection) return;
    
    // Check container position instead of section position
    const containerRect = currentSection.container.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const containerCenter = (containerRect.top + containerRect.bottom) / 2;
    const viewportCenter = windowHeight / 2;
    const containerHeight = containerRect.height;
    
    // More precise exit condition - based on container visibility and position
    const distanceFromCenter = Math.abs(containerCenter - viewportCenter);
    const isContainerStillCentered = distanceFromCenter < containerHeight * 0.4;
    const isContainerVisible = containerRect.top < windowHeight && containerRect.bottom > 0;
    
    if (!isContainerStillCentered || !isContainerVisible) {
        wheelAccumulator = 0;
        resumeNormalScroll();
        return;
    }
    
    e.preventDefault();
    
    const currentTime = Date.now();
    const timeDelta = currentTime - lastWheelTime;
    lastWheelTime = currentTime;
    
    const isTouchpad = Math.abs(e.deltaY) < 50 && timeDelta < 50;
    
    if (isTouchpad) {
        handleTouchpadScroll(e, currentSection);
    } else {
        handleMouseWheelScroll(e, currentSection);
    }
}

function startSwiperHijacking(sectionData) {
    isScrollHijacked = true;
    currentHijackedSwiper = sectionData.id;
    lenis.stop();
    
    const swiper = sectionData.swiper;
    swiper.mousewheel.enable();
    
    // Add event listeners for swiper navigation
    swiper.on('reachEnd', handleSwiperEnd);
    swiper.on('reachBeginning', handleSwiperBeginning);
    
    // Add visual indicator
    sectionData.container.setAttribute('data-scroll-hijack', 'true');
}

function getCurrentHijackedSection() {
    return swiperSections.find(section => section.id === currentHijackedSwiper);
}

function handleTouchpadScroll(e, currentSection) {
    if (isProcessingWheel) return;
    
    const delta = e.deltaY;
    const swiper = currentSection.swiper;
    
    // Accumulate small touchpad movements
    wheelAccumulator += delta;
    
    // Clear existing timeout
    if (wheelTimeout) {
        clearTimeout(wheelTimeout);
    }
    
    // Set timeout to process accumulated scroll
    wheelTimeout = setTimeout(() => {
        if (Math.abs(wheelAccumulator) > 30) { // Threshold for touchpad
            isProcessingWheel = true;
            
            if (wheelAccumulator > 0) {
                // Scroll down - next slide
                if (!swiper.isEnd) {
                    swiper.slideNext();
                } else {
                    // If at end, resume and continue scrolling
                    resumeNormalScroll();
                    setTimeout(() => {
                        window.scrollBy({
                            top: 100,
                            behavior: 'smooth'
                        });
                    }, 100);
                }
            } else {
                // Scroll up - previous slide
                if (!swiper.isBeginning) {
                    swiper.slidePrev();
                } else {
                    // If at beginning, resume and continue scrolling
                    resumeNormalScroll();
                    setTimeout(() => {
                        window.scrollBy({
                            top: -100,
                            behavior: 'smooth'
                        });
                    }, 100);
                }
            }
            
            // Reset accumulator and processing flag
            wheelAccumulator = 0;
            setTimeout(() => {
                isProcessingWheel = false;
            }, 300); // Debounce period
        }
    }, 50); // Short delay to accumulate touchpad events
}

function handleMouseWheelScroll(e, currentSection) {
    if (isProcessingWheel) return;
    
    const delta = e.deltaY;
    const swiper = currentSection.swiper;
    
    isProcessingWheel = true;
    
    if (delta > 0) {
        // Scroll down - next slide
        if (!swiper.isEnd) {
            swiper.slideNext();
        } else {
            // If at end, immediately resume and continue scrolling
            resumeNormalScroll();
            setTimeout(() => {
                window.scrollBy({
                    top: 150,
                    behavior: 'smooth'
                });
            }, 50);
        }
    } else {
        // Scroll up - previous slide
        if (!swiper.isBeginning) {
            swiper.slidePrev();
        } else {
            // If at beginning, immediately resume and continue scrolling
            resumeNormalScroll();
            setTimeout(() => {
                window.scrollBy({
                    top: -150,
                    behavior: 'smooth'
                });
            }, 50);
        }
    }
    
    // Reset processing flag for mouse wheel
    setTimeout(() => {
        isProcessingWheel = false;
    }, 200);
}

// Also update your resumeNormalScroll function to clear wheel-related variables
function resumeNormalScroll() {
    if (isScrollHijacked && currentHijackedSwiper) {
        const currentSection = getCurrentHijackedSection();
        if (currentSection) {
            const swiper = currentSection.swiper;
            swiper.mousewheel.disable();
            
            // Remove event listeners
            swiper.off('reachEnd', handleSwiperEnd);
            swiper.off('reachBeginning', handleSwiperBeginning);
            
            // Remove visual indicator
            currentSection.container.removeAttribute('data-scroll-hijack');
        }
        
        isScrollHijacked = false;
        currentHijackedSwiper = null;
        
        // Reset wheel-related variables
        wheelAccumulator = 0;
        isProcessingWheel = false;
        if (wheelTimeout) {
            clearTimeout(wheelTimeout);
            wheelTimeout = null;
        }
        
        // Restart Lenis immediately for smoother transition
        lenis.start();
    }
}

function handleSwiperEnd() {
    // Don't auto-scroll to sections, let user control the flow
}

function handleSwiperBeginning() {
    // Don't auto-scroll to sections, let user control the flow  
}


/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */